<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="productOtherCodeId" :primary-key="form.productOtherCodeId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Códigos de Conversão"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.productOtherCodeId" hidden/>

      <b-col cols="12" class="mb-2">

        <t-input v-model="form.typeRelation" label="Tipo de Conversão" hide-label :options="OtherCodeType.list" radio
                 required/>

        <b-row>

          <b-col xl="9">

            <b-row>


              <b-col cols="9" v-if="form.typeRelation === OtherCodeType.type.CUSTOMER">
                <t-input-person customer
                                v-model="form.customerId" required />
              </b-col>


              <t-input cols="9" v-if="form.typeRelation === OtherCodeType.type.GROUP_CUSTOMER"
                       v-model="form.customerGroupId"
                       label="Grupo de Cliente"
                       :options="groupCustomerOptions" required select/>

              <t-input cols="9" v-if="form.typeRelation === OtherCodeType.type.MARKET_CODE" v-model="form.marketCodeId"
                       label="Código de Mercado"
                       :options="marketCodeOptions" required select/>


              <t-input cols="3" v-model="form.code" ref="firstInput" submitted :add-error="error.code" label="Código" required/>


            </b-row>

          </b-col>

          <b-col xl="3" class="button-form-inline">

            <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

            <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
              {{ t('go-back') }}
            </b-link>

          </b-col>


        </b-row>


      </b-col>


    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import OtherCodeType from "@/model/types/modules/product/OtherCodeType";
import http from "@/services/config/http-common";


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'ProductKit',
  data() {
    return {
      OtherCodeType,
      path: "product/item-other-code", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "productId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "productOtherCodeId", keyDelete: "productOtherCodeId"},
        {key: "typeRelationName", label: "Tipo", cols: "2"},
        {key: "typeRelationDescription", label: "Descrição", cols: "5"},
        {key: "code", label: "Código", cols: "2"},
      ],
      form: {
        productId: this.foreignKey,
        productOtherCodeId: 0,
        typeRelation: 1,
        customerId: 0,
        customerGroupId: 0,
        marketCodeId: 0,
        code: "",
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        code: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
        "typeRelation",
      ],
      //--------------------------------------------------------------------------------------
      groupCustomerOptions: [],
      marketCodeOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      this.form.typeRelation = 1


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await http.list(this.path + "/selectRelationList").then((response) => {
        this.groupCustomerOptions = response.groupCustomerOptions
        this.marketCodeOptions = response.marketCodeOptions
      }).catch(error => this.responseError(error))

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.productOtherCodeId)

    },

    mountedList() {


      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
